var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"documentation-widget",class:{ 'documentation-widget-active': _vm.open },on:{"click":_vm.toggleWidget}},[_c('i',{staticClass:"fa-light fa-circle-question"})])
}
var staticRenderFns = []

export { render, staticRenderFns }